import 'cross-fetch/polyfill';
export async function fetchPrivate(input, init) {
    const defaultFetchOpts = {
        referrer: 'no-referrer',
        referrerPolicy: 'no-referrer',
    };
    const fetchOpts = Object.assign(defaultFetchOpts, init);
    const fetchResult = await fetch(input, fetchOpts);
    return fetchResult;
}
//# sourceMappingURL=fetchUtil.js.map